<div class="mdc-component-wrapper terms-conditions-container">
  <form [formGroup]="resolvedFormGroup()">
    <div class="terms-checkbox-row" [class.pointers]="allowPointerEvents()">
      @for (input of configJson().inputs; track (input.id ?? 'terms-input-' + $index); let inputIndex = $index) {
        <mat-checkbox
          class="pc-terms-checkbox"
          [aria-label]="input.label ?? 'checkbox-label'"
          [aria-labelledby]="'terms-checkbox-text-' + inputIndex"
          [formControl]="getCheckboxControl(enrollmentBuilderView() ? 'adminFormName' : input.id)"
          (change)="checkboxClick($event.checked)">
          <span class="checkbox-text" [id]="'terms-checkbox-text-' + inputIndex">
            @for (part of (labelParts()[inputIndex] ?? []); track ((part.href ?? part.text) + '-' + $index)) {
              @if (part.href) {
                <a [href]="part.href" class="mdc-link-blank" rel="noopener noreferrer" target="_blank">{{ part.text }}</a>
              } @else {
                {{ part.text }}
              }
            }
            @if (input.isRequired) {
              <span aria-hidden="true">*</span>
            }
          </span>
        </mat-checkbox>
      }
    </div>
  </form>
</div>
